export function GetEnrollmentSelected<T>(): T {
  var enrollment = localStorage.getItem('currentEnrollmentAgendamento');
  return enrollment as unknown as T;
}

export function SetEnrollmentSelected(value: string): void {
  localStorage.setItem('currentEnrollmentAgendamento', value);
}
